module.exports = __webpack_public_path__ + "img/icons B_11.f92653ea.svg";